import React from 'react';

const UpgradeAgentPanel = () => {
  return (
    <div className="enterprise-panel">
      <div className="panel-header">
        <h2>Upgrade Agent</h2>
        <p className="subtitle">Automated Code & Website Improvements</p>
      </div>
      <div className="panel-content">
        <div className="empty-state">
          <h3>Ready for Deployment</h3>
          <p>Describe the features or refactoring you want, and the agent will plan and execute the upgrades.</p>
        </div>
      </div>
    </div>
  );
};

export default UpgradeAgentPanel;
